import type { Me } from '@myrewards/contracts';

/**
 * The act-for switches as `me` carries them (APP-148 D1); a server that doesn't send them is
 * taken at the switches' default, on.
 */
export function actForSwitches(me: Pick<Me, 'features'>): {
  executives: boolean;
  sectorLeads: boolean;
} {
  return me.features?.actingFor ?? { executives: true, sectorLeads: true };
}

/** A Stock Admin while acting for Executives is on: the Executives' decisions are theirs to do for them. */
export function actsForExecutivesNow(me: Pick<Me, 'roles' | 'features'>): boolean {
  return me.roles.some((r) => r.role === 'stock_admin') && actForSwitches(me).executives;
}

/**
 * A Stock Admin who isn't an Executive, while either switch is on: their Approvals is Waiting on
 * others, under Home (D2), and so is every approval and recording they open from it (R60). With
 * both off, it's as it was before APP-148.
 */
export function approvalsUnderHome(me: Pick<Me, 'roles' | 'features'>): boolean {
  const roles = new Set(me.roles.map((r) => r.role));
  const switches = actForSwitches(me);
  return (
    roles.has('stock_admin') &&
    !roles.has('executive') &&
    (switches.executives || switches.sectorLeads)
  );
}
